/** ----------------------------------------
    Home
 ---------------------------------------- */

/**
 * This class will initiate the home slider
 */

export class Home {

    /**
     * @init            calls the init method
     */

    constructor() {
        this.active = 1;
        this.interval = '';
        this.length = '';
        this.slides = '';
        this.init();
    }

    /** ----------------------------------------
        Home Slides
     ---------------------------------------- */

    setSlides() {
        this.slides = document.querySelectorAll('.header__slide');
        this.length = this.slides.length;
    }

    setActive(slide) {
        this.active = parseInt(slide.dataset.id);
    }

    setActiveTab(id) {
        let tabs = document.querySelectorAll('.header__tab');

        for(let tab of tabs) {
            tab.classList.remove('is-active');

            if(tab.dataset.index === id)
                tab.classList.add('is-active');
        }
    }

    /** ----------------------------------------
        Select Slide
     ---------------------------------------- */

    toggleClass(slide) {
        for(let slide of this.slides) {
            slide.classList.remove('is-active');
        }

        slide.classList.toggle('is-active');

        this.setActive(slide);
        this.setActiveTab(slide.dataset.id);
    }

    /** ----------------------------------------
        Select Slide
     ---------------------------------------- */

    tabClickEvent() {
        let tabs = document.querySelectorAll('.header__tab');

        for(let tab of tabs) {
            tab.addEventListener('click', () => {
                let index = tab.dataset.index;
                this.findSlide(index);
                this.refreshAutoplay();
            });
        }
    }

    arrowClickEvent() {
        let arrows = document.querySelectorAll('.slider__arrow');

        for(let arrow of arrows) {
            arrow.addEventListener('click', () => {
                arrow.classList.contains('slider__arrow--next') ? this.nextSlide() : this.previousSlide();
                this.refreshAutoplay();
            });
        }
    }

    nextSlide() {
        let select = this.active + 1;

        if(select > this.length)
            select = 1;

        this.findSlide(select);
    }

    previousSlide() {
        let select = this.active - 1;

        if(select < 1)
            select = this.length;

        this.findSlide(select);
    }

    /** ----------------------------------------
        Find Slide
     ---------------------------------------- */

    findSlide(id) {
        let slider = document.querySelector('.header__slider');
        let slides = slider.children;

        for(let slide of slides) {
            if(parseInt(slide.dataset.id) === parseInt(id)) {
                this.toggleClass(slide);
                this.active = id;
            }
        }
    }

    /** ----------------------------------------
        Autoplay
     ---------------------------------------- */

    autoplayEvent() {
        this.interval = setInterval(() => {
            this.nextSlide();
        }, 7500)
    }

    refreshAutoplay() {
        clearInterval(this.interval);
        this.autoplayEvent();
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    init() {
        let header = document.querySelector('.header__home');

        if(!header)
            return;

        this.setSlides();
        this.tabClickEvent();
        this.arrowClickEvent();
        this.setActiveTab(1);
        this.autoplayEvent();
    }
}
